import { containerEvents } from "../../ContainerEvents";
import { graphic } from "../../Graphic";

export class PanEditionMode {

    constructor({ zoomAtScroll = true } = {}) {
        this.initialPosition = null;
        this.isEnableTranslate = true;
        this.lastDist = null;
        this.cursorModeBeforeMove = null;

        graphic.lastTranslatePoint = {
            x: graphic.container.position.x - graphic.container.pivot.x,
            y: graphic.container.position.y - graphic.container.pivot.y
        };

        this.zoomAtScroll = zoomAtScroll;
        this.keys = {37: 1, 38: 1, 39: 1, 40: 1};

        this.onWheelBind = this.onWheel.bind(this);
        graphic.parentElement.addEventListener('wheel', this.onWheelBind);
    }

    destroy() {
        graphic.parentElement.removeEventListener('wheel', this.onWheelBind);
        if (!this.cursorModeBeforeMove) {
            this.cursorModeBeforeMoved = graphic.app.stage.cursor;
        }
    }

    onWheel(e) {
        e.preventDefault();
        if (!this.zoomAtScroll) return;

        const direction = Math.sign(e.deltaY) * -1;
        if (direction) graphic.setZoom({
            direction,
            origin: containerEvents.mouseCoords
        });
    }

    onStartClick() {
        this.initialPosition = containerEvents.originalMouseCoords;
    }

    onStopClick() {
        // Reset pan edition mode
        graphic.app.stage.cursor = null;
        this.destroy();
        Object.assign(this, new PanEditionMode({ zoomAtScroll: this.zoomAtScroll }));
    }

    onMoveMouse() {
        if (this.initialPosition === null || !this.isEnableTranslate) return;

        if (!this.cursorModeBeforeMove) {
            this.cursorModeBeforeMoved = graphic.app.stage.cursor;
        }
        graphic.app.stage.cursor = 'move';

        const dist = {
            x: containerEvents.originalMouseCoords.x - this.initialPosition.x,
            y: containerEvents.originalMouseCoords.y - this.initialPosition.y
        };

        const translate = {
            x: this.lastDist ? dist.x - this.lastDist.x : dist.x,
            y: this.lastDist ? dist.y - this.lastDist.y : dist.y
        };
        translate.x = translate.x > 50 ? 0 : translate.x;
        translate.y = translate.y > 50 ? 0 : translate.y;

        graphic.translate(translate);

        this.lastDist = dist;

        /*let translate = dist;
        if (this.lastDist) {
            translate.x = dist.x - this.lastDist.x;
            translate.y = dist.y - this.lastDist.y;
        }
        console.log(translate);
        graphic.translate(translate);

        this.lastDist = dist;*/
    }
}